<sw-page class="dvsn-form-builder dvsn-form-builder-form-list">
    <template #search-bar>
        <sw-search-bar
            :initialSearchType="$t('dvsn-form-builder-form.list.search.type')"
            :placeholder="$t('dvsn-form-builder-form.list.search.placeholder')"
            :initialSearch="term"
            @search="onSearch"
        />
    </template>

    <template #smart-bar-actions>
        <dvsn-form-builder-in-app
            :isLoading="isLoading"
            :count="countForms"
        />

        <mt-button
            variant="primary"
            size="default"
            :disabled="planLimitReached"
            @click="$router.push({ name: 'dvsn.form.builder.form.create' })"
        >
            {{ $t('dvsn-form-builder-form.list.actions.add') }}
        </mt-button>
    </template>

    <template #side-content>
        <dvsn-form-builder-side-menu
            active="form"
            :isLoading="isLoading"
        ></dvsn-form-builder-side-menu>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="forms"
            :items="forms"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :showActions="true"
            :showSelection="false"
            :showSettings="false"
            detailRoute="dvsn.form.builder.form.detail"
            @page-change="onPageChange"
        >
            <template #column-name="{ item }">
                <router-link
                    :title="$t('dvsn-form-builder-form.list.column-name')"
                    :to="{ name: 'dvsn.form.builder.form.detail', params: { id: item.id } }"
                >
                    {{ item.name }}
                </router-link>
            </template>

            <template #column-createdAt="{ item }">
                {{ dateFilter(item.createdAt, {hour: '2-digit', minute: '2-digit', second: '2-digit'}) }} Uhr
            </template>
        </sw-entity-listing>

        <mt-loader v-if="isLoading"/>
    </template>

    <template #sidebar>
        <sw-sidebar>
            <sw-sidebar-item
                icon="regular-undo"
                :title="$t('dvsn-form-builder-form.list.sidebar.refresh')"
                @click="onRefresh"
            />
        </sw-sidebar>
    </template>
</sw-page>